











































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { SensorsApi, Sensor, Transceiver } from '@/api';
import { VueSelect } from 'vue-select';
import { Validation } from 'vuelidate';

@Component({
	components: { VueSelect },
})
export default class SensorSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	@PropSync('sensor') public localSensor!: Sensor;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Boolean)
	public readonly state?: boolean;

	@Prop(Number)
	public transceiverId?: number;

	@Prop(String)
	public type: string | '';

	public options: Sensor[] = [];
	private api: SensorsApi;

	constructor() {
		super();
		this.api = new SensorsApi();
		this.debouncedOptions = debounce(this.fetchOptions);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.localSensor = item;
		this.$emit('input', item);
	}

	public onSearch(search: string) {
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public async fetchOptions(search: string) {
		const options: any = {
			params: {
				include: 'node,transceiver.site',
				'filter[serialNumber]': search,
				'filter[type]': this.type,
				'filter[transceiverId]': this.transceiverId,
			},
		};
		try {
			const response = await this.api.getSensors(options);
			this.options = response.data.data;
		} catch (e) {
			console.log(e);
		}
		if (this.type === 'capacitance') {
			options.params = {
				include: 'transceiver.site',
				'filter[serialNumber]': search,
				'filter[type]': this.type,
				perPage: 250,
			};
			try {
				const response = await this.api.getSensors(options);

				let otherSensors = response.data.data.filter(sensor => {
					return !new Set(this.options).has(sensor);
				});

				// response.data.data.forEach(r=>(this.options = this.options.filter(o=>o.id !== r.id)));
				this.options = this.options.concat(otherSensors) || [];
			} catch (e) {
				console.log(e);
			}
		} else {
		}
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
